import { Component, Vue } from 'vue-property-decorator';
import SettingService from '@/modules/services/setting.service';

const settingService = new SettingService();

@Component
export default class Security extends Vue {
  public flag = false
  public successMessage = ''
  public otp_token = ''
  public admin_flag:boolean = false
  public created() {
    $(document).prop('title', 'Dshop Security')
    this.mfaFlasgSet();
  }

  private mfaFlasgSet() {
    this.$store.state.Loading = true;
    settingService.mfaFlasgSet().then((res: any) => {
      this.$store.state.Loading = false;
      this.flag = res.data.data.flag
      this.admin_flag = res.data.data.admin_flag
      console.log(res.data.data)
      this.otp_token = "token"+res.data.data.user_id
      if (!this.flag && !this.admin_flag){
        console.log("OTP - "+this.otp_token)
        this.$cookies.remove(this.otp_token)
      }
    }, (err: any) => {
      this.$store.state.Loading = false;
    })
  }

  private DisableMfa() {
    console.log("clicked to diabled")
    settingService.DisableMfa().then((response: any) => {
      this.successMessage = response.data.data.message;
      this.otp_token = "token" + response.data.data.user_id;
      console.log("Token String - " + this.otp_token)
      if (response.data.data.status === true) {
        this.$cookies.remove(this.otp_token)
        this.$store.dispatch('showSuccessMsg', this.successMessage);
        setTimeout(() => {
          this.$router.push('/dashboard');
        }, 2000);
      } else {
        this.$store.dispatch('showErrorMsg', this.successMessage);
      }
    }, (err: any) => {
      this.$store.dispatch('showErrorMsg', err.message);
    });
  }

}
